export namespace SoftwareVersionCoverageActions {
    export class SetAllSoftwareVersionCoverages {
      static readonly type = '[softwareVersionCoverage] SetAllSoftwareVersionCoverages';
      constructor() {}
    }
    export class SetMySoftwareVersionCoverages {
      static readonly type = '[softwareVersionCoverage] SetMySoftwareVersionCoverages';
      constructor(public userId: string) {}
    }
  
    export class DeleteSoftwareVersionCoverage {
      static readonly type = '[softwareVersionCoverage] DeleteSoftwareVersionCoverage';
      constructor(public softwareVersionCoverageUid: string, public regBy: string) {}
    }

    export class UpdateItem {
      static readonly type = '[softwareVersionCoverage] UpdateItem';
      constructor(public item: any) {}
    }

    export class ClearCache {
      static readonly type = '[softwareVersionCoverage] ClearCache';
      constructor() {}
    }
  }
  